<template>
  <div class="m-card-primary m-the-modal-content m-plan-personalizado">
      <header class="m-the-modal-header">
        <h5 class="m-plan-personalizado-titulo">
          <i class="fas fa-headset"></i>
          {{ $t('mEditionBillingMyPaymentsChangePlanModalCustomized.title') }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <!-- El mismo bloque "Plan personalizado" que las apps de los Droops: el correo se copia
             con un clic, en vez de un mailto que abre un cliente de correo que nadie configuro -->
        <p class="m-plan-personalizado-texto margin-bottom-xlarge">
          {{ $t('mEditionBillingMyPaymentsChangePlanModalCustomized.messages') }}
          {{ $t('mEditionBillingMyPaymentsChangePlanModalCustomized.contactBefore') }}
          <button
            type="button"
            class="m-plan-personalizado-email"
            :class="{ copiado }"
            :title="$t('mEditionBillingMyPaymentsChangePlanModalCustomized.copyTitle')"
            @click="copiar"
          >{{ $t('mEditionBillingMyPaymentsChangePlanModalCustomized.email') }}
            <i :class="copiado ? 'fas fa-check' : 'far fa-copy'"></i></button>
          {{ $t('mEditionBillingMyPaymentsChangePlanModalCustomized.contactAfter') }}
          <span
            v-if="copiado"
            class="m-plan-personalizado-aviso"
            role="status"
          >
            {{ $t('mEditionBillingMyPaymentsChangePlanModalCustomized.copied') }}
          </span>
        </p>
      </section>
  </div>
</template>

<script>
/*
 | Se abre cuando la venta combina la licencia Vidroop con licencias de Droops (venta.satelites):
 | ese plan es personalizado y no se cambia desde la seccion de cambio de plan. El backend sigue
 | aceptando la combinacion (CreateVentaByChangePlanService): la barandilla es del front, a
 | proposito, para que un producto a medida se pueda seguir cambiando por el enlace de cambio de
 | plan personalizado que arma Vidroop desde precios y planes.
 */
export default {
  name: 'MoleculeEditionBillingMyPaymentsChangePlanModalCustomized',

  data () {
    return {
      copiado: false
    }
  },

  methods: {
    copiar () {
      const email = this.$t('mEditionBillingMyPaymentsChangePlanModalCustomized.email')
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        // Sin portapapeles no hay nada que avisar: el correo esta escrito para copiarlo a mano
        return
      }
      navigator.clipboard.writeText(email)
        .then(() => {
          this.copiado = true
          setTimeout(() => { this.copiado = false }, 2500)
        })
        .catch(() => {})
    }
  }
}
</script>
